import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { trackFeatureUsage } from "utilities/trackFeatureUsage";
import Input from "component/form/Input";
import ErrorMessage from "./ErrorMessage";
import { SecureAuth } from "asset/icons";
import axios from "axios";
import Loader from "component/loader";

const RecoverPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            trackFeatureUsage("recover_password", email);

            const res = await axios.post("/v1/users/send-forgot-password", { email });
            setLoading(false);

            navigate("/auth/verify-email", {
                state: { email, flow: "recover" },
            });
        } catch (err) {
            setLoading(false);
            setError(
                err?.response?.data?.message || "Failed to process request. Please try again."
            );
        }
    };

    return (
        <div className="bg-white rounded-xl w-[600px]">
            {/* Icon or Logo */}
            <div className="!pt-5">
                <SecureAuth />
            </div>
            <div className="p-8 !pt-0">
                {/* Heading */}
                <h2 className="text-2xl font-bold text-gray-900">Recover password</h2>
                <p className="text-sm text-gray-500 mt-2">What’s your email address?</p>

                {/* Form */}
                <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                    <Input
                        type="email"
                        placeholder="Email address"
                        value={email}
                        onChange={(e) => setEmail(e)}
                        required
                    />

                    <ErrorMessage message={error} />
                    <div className="flex justify-between items-center">
                        <p className="text-sm text-gray-500 mt-4">
                            Don’t have an account?{" "}
                            <span
                                onClick={() => navigate("/auth/signup")}
                                className="text-[#6F00FF] font-medium cursor-pointer"
                            >
                                Create one
                            </span>
                        </p>
                        <button
                            type="submit"
                            disabled={loading}
                            className={`bg-[#6F00FF] text-white text-sm px-4 py-2 rounded-lg mt-4 hover:bg-[#6f00fff0] transition ${
                                loading ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                        >
                            {loading ? <Loader /> : "Send OTP"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RecoverPassword;
